
const servicesData = [
    {
        name: "Exterior Detailing",
        note: "* prices vary upon severity & size of vehicle",
        description: [
            {
                name: "Hand wash & dry",
            },
            {
                name: "Apply wax & sealant",
            },
            {
                name: "Apply tires dressing",
            },
            {
                name: "Wipe down windows & door jambs",
            }
        ],
        Add_On: [
            {
                name: "Headlight Restoration",
                price: 80
            },
            {
                name: "Water Spot Removal",
                price: 80
            },
            {
                name: "Engine Bay Cleaning",
                price: 100
            }
        ]
    },
    {
        name: "Full Detailing",
        note: "* Full Detailing includes basic exterior & interior Detailing",
        description: [],
        Add_On: [
            {
                name: "Excess trash removal",
                price: 30
            },
            {
                name: "Excess pet hair removal",
                price: 50
            },
            {
                name: "Headlight Restoration",
                price: 80
            },
            {
                name: "Shampoo & extract seats/carpets",
                price: 80
            },
            {
                name: "Water Spot Removal",
                price: 80
            },
            {
                name: "Engine Bay Cleaning",
                price: 100
            },
            {
                name: "Urine, Feces, Vomit & Stains removal",
                price: 100
            },
            {
                name: "Odor removal",
                price: 150
            }
        ]
    },
    {
        name: "Interior Detailing",
        note: "* prices vary upon severity & size of vehicle",
        description: [
            {
                name: "Vaccum interior & rear",
            },
            {
                name: "Clean dashboard, steering wheel & center console",
            },
            {
                name: "Steam clean door panels & door jambs",
            },
            {
                name: "Wipe down windows with crisp RTU glass cleaner",
            },
            {
                name: "Applied UV protective dressings",
            },
            {
                name: "Air sanitizer (Kills 99.9% of germs. Good for allergies & Kids)",
            }
        ],
        Add_On: [
            {
                name: "Excess trash removal",
                price: 30
            },
            {
                name: "Excess pet hair removal",
                price: 50
            },
            {
                name: "Shampoo & extract seats/carpets",
                price: 80
            },
            {
                name: "Urine, Feces, Vomit & Stains removal",
                price: 100
            },
            {
                name: "Odor removal",
                price: 150
            }
        ]
    }
]

export default servicesData;